import { Component, ViewChild } from "@angular/core";
import { routerTransition } from "../animations"
import { AngularFireDatabase } from 'angularfire2/database';
import { AuthService } from '../auth.service';
import { QuibblGridComponent } from '../common/quibbl-grid/quibbl-grid.component';

@Component({
    styleUrls: ['./home.component.scss'],
    templateUrl: './home.component.html',
    animations: [routerTransition()],
    host: {'[@routerTransition]': ''}
})
export class HomeComponent {

  public introText = "Loading...";
  @ViewChild('quibblGrid') private quibblGrid: QuibblGridComponent;

  constructor(private af: AngularFireDatabase, public auth: AuthService) { }

  ngOnInit() {
    this.af.object('/static/intro').$ref.once("value").then(about => {
      this.introText = about.val();
    });
  }

  didScroll(event) {
    let offset = (event.target.scrollHeight) ? event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight
                                             : event.target.scrollingElement.scrollHeight - event.target.scrollingElement.scrollTop - event.target.defaultView.innerHeight;
    //console.log(offset);
    if(offset < 240) {
      this.quibblGrid.fetchMoreQuibbls();
    }
  }

}



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/home/home.component.ts